<template>
    <div class="v-schedule__p-metagroup">
        <span class="v-schedule__p-metaname">Пациент</span>
        <span class="v-schedule__p-metavalue" v-if="!cell.appointment.consultation.anonym">
            <a v-if="!cell.appointment.consultation.patient.user.deleted_at" :href="url" v-html="name"></a>

            <span v-else v-html="name"></span>
        </span>
        <span class="v-schedule__p-metavalue" v-else="!cell.appointment.consultation.anonym">Аноним</span>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';

    dayjs.extend(utc);

    export default {
        name: 'CalendarPopupMeta',
        props: {
			cell: {
                type: Object,
                required: true
            },
        },
        computed: {
            name() {
                return this.cell.appointment.consultation.family ? this.cell.appointment.consultation.family.name
                    : this.cell.appointment.consultation.patient.user.name;
            },
            url() {
                return this.cell.appointment.consultation.family ? '/family/' + this.cell.appointment.consultation.family.slug :
                    '/patient/' +  this.cell.appointment.consultation.patient.id;
            }
        }
    }
</script>

